import { observable, computed, makeAutoObservable } from 'mobx';
import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import { reduxImmutableHash } from './utils/reduxImmutableHash';
import { ReduxRawState } from './utils/ReduxRawState';
import { MobxMapAutoNew } from 'src_common/common/mobx-utils/MobxMapAutoNew';

class EventCheck {
    constructor(
        private readonly eventId: number,
        private readonly getEvents: () => Array<number>
    ) {
        makeAutoObservable(this);
    }

    @computed get isOpened(): boolean {
        return this.getEvents().includes(this.eventId);
    }
}

const isEventsList = createGuard(t.array(t.number));

export class ReduxEventsOpened {
    @observable.ref private eventsOpened: Array<number> = [];

    private readonly events: MobxMapAutoNew<number, EventCheck>;

    constructor(reduxStore: ReduxRawState) {
        this.events = new MobxMapAutoNew((eventId: number) => {
            return new EventCheck(eventId, () => this.eventsOpened);
        });

        reduxImmutableHash(
            reduxStore,
            (state: Record<string, unknown>): unknown => {
                //@ts-expect-error
                return state.events.get('opened');
            },
            (data: unknown): void => {
                if (isEventsList(data)) {
                    this.eventsOpened = data;
                } else {
                    console.error('ReduxEventsOpened - Decode error', data);
                }
            }
        );
        makeAutoObservable(this);
    }

    public isOpened(eventId: number): boolean {
        return this.events.get(eventId).isOpened;
    }

    public getOpenedEvents(): Array<number> {
        return this.eventsOpened;
    }
}
